/**
 * @since 0.14.0
 * @component
 */
export default {
  MIN_CONTENT_WIDTH: 320,
  MAX_CONTENT_WIDTH: 1140,
  DEFAULT_COL: 6,
  DEFAULT_COL_WIDTH: 200,
} as const;
